var exports = {
  "f": "x936d19a0--bf4df9--options",
};

module.exports = exports;
